import { z } from 'zod'

const uuid = z
  .string()
  .regex(
    /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i,
    'Must be a valid UUID (xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx)',
  )

export const customerSchema = z.object({
  customer_name: z.string().min(1, 'Name is required').max(100, 'Max 100 characters'),
  tenant_id: uuid.or(z.literal('')).optional(),
  tier: z.enum(['basic', 'standard', 'premium']),
  requests_per_hour: z.coerce.number().min(100, 'Minimum 100').max(10000, 'Maximum 10 000'),
  requests_per_day: z.coerce.number().min(1000, 'Minimum 1 000').max(100000, 'Maximum 100 000'),
})

export const credentialSchema = z.object({
  customer_id: z.string().min(1, 'Select a customer'),
  tenant_id: uuid,
  client_id: uuid,
  client_secret: z.string().min(1, 'Secret is required'),
})

export type CustomerFormValues = z.infer<typeof customerSchema>
export type CredentialFormValues = z.infer<typeof credentialSchema>
